export default function initMobileMenu() {
  const switcher = document.querySelector(".header-nav-switcher");
  const menu = document.querySelector(".header-menu");

  if (!menu || !switcher) {
    return;
  }
  switcher.addEventListener("click", function (event) {
    event.preventDefault();
    menu.classList.toggle("header-menu-show");
  });

  menu.addEventListener("click", function (event) {
    // event.preventDefault();
    // event.stopImmediatePropagation();
    // event.stopPropagation();
    const target = event.target;
    if (!target.closest(".header-menu > li > a")) {
      return;
    }

    const parent = target.closest(".menu-item-has-children");
    if (!parent) {
      return;
    }
    const siblingSubMenu = parent.querySelector(".sub-menu");
    siblingSubMenu.classList.toggle("show");
  });

//   document.addEventListener("click", function (event) {
//     const target = event.target;
//     const isMenuAreaClicked = !!target.closest('.header-menu-show');
//     if (!isMenuAreaClicked && target !== switcher) {
//         menu.classList.remove('header-menu-show')
//         console.log('ok');
//     }
//   });
}
